import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations.ts';

import type { AdfStats } from './useAdfStats.tsx';

type IsComplexPageReason = 'TooManyNodes' | 'TooManyExtensions' | 'None';

type UseProgressiveRenderingConfigResponseType = {
	isComplexPage: boolean;
	isComplexPageReason: IsComplexPageReason;
	batchSize: number;
};

type UseProgressiveRenderingConfigProps = {
	skip?: boolean;
	totalNodeCount: AdfStats['totalNodeCount'];
	nodeCountByType: AdfStats['nodeCountByType'];
};

export const useProgressiveRenderingConfig = ({
	skip,
	totalNodeCount,
	nodeCountByType,
}: UseProgressiveRenderingConfigProps): UseProgressiveRenderingConfigResponseType => {
	let isComplexPage = false;
	let isComplexPageReason: IsComplexPageReason = 'None';
	let batchSize = 0;

	if (!skip) {
		const defaultConfig = StatsigConfigurations.getString(
			'cc_complexit_fe_progressive_adf_rendering_configs',
			'',
		).split(',');
		const batchSizeConfig = Number(defaultConfig[0]) || 1000;
		const multiplierConfig = Number(defaultConfig[1]) || 1;

		// Figure out whether progressive rendering is to be enabled:
		if (totalNodeCount >= batchSizeConfig * multiplierConfig) {
			isComplexPage = true;
			isComplexPageReason = 'TooManyNodes';
			batchSize = batchSizeConfig;
		} else if (
			(nodeCountByType['extension'] || 0) +
				(nodeCountByType['inlineExtension'] || 0) +
				(nodeCountByType['bodiedExtension'] || 0) +
				(nodeCountByType['multiBodiedExtension'] || 0) >
			4
		) {
			isComplexPage = true;
			isComplexPageReason = 'TooManyExtensions';
		}
	}

	return {
		isComplexPage,
		isComplexPageReason,
		batchSize,
	};
};
